(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[405],{

/***/ 11215:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(9652);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutPropertiesLoose__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(22238);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(60822);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69515);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94273);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(75360);


var _excluded = ["className", "cssModule", "color", "body", "inverse", "outline", "tag", "innerRef"];




var propTypes = {
  tag: _utils__WEBPACK_IMPORTED_MODULE_2__/* .tagPropType */ .iC,
  inverse: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().bool),
  color: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().string),
  body: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().bool),
  outline: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().bool),
  className: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().string),
  cssModule: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().object),
  innerRef: prop_types__WEBPACK_IMPORTED_MODULE_3___default().oneOfType([(prop_types__WEBPACK_IMPORTED_MODULE_3___default().object), (prop_types__WEBPACK_IMPORTED_MODULE_3___default().string), (prop_types__WEBPACK_IMPORTED_MODULE_3___default().func)])
};
var defaultProps = {
  tag: 'div'
};

var Card = function Card(props) {
  var className = props.className,
      cssModule = props.cssModule,
      color = props.color,
      body = props.body,
      inverse = props.inverse,
      outline = props.outline,
      Tag = props.tag,
      innerRef = props.innerRef,
      attributes = (0,_babel_runtime_helpers_esm_objectWithoutPropertiesLoose__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(props, _excluded);

  var classes = (0,_utils__WEBPACK_IMPORTED_MODULE_2__/* .mapToCssModules */ .mx)(classnames__WEBPACK_IMPORTED_MODULE_1___default()(className, 'card', inverse ? 'text-white' : false, body ? 'card-body' : false, color ? (outline ? 'border' : 'bg') + "-" + color : false), cssModule);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(Tag, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, attributes, {
    className: classes,
    ref: innerRef
  }));
};

Card.propTypes = propTypes;
Card.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["Z"] = (Card);

/***/ }),

/***/ 65322:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(9652);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutPropertiesLoose__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(22238);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(60822);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69515);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94273);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(75360);


var _excluded = ["className", "cssModule", "tag"];




var propTypes = {
  tag: _utils__WEBPACK_IMPORTED_MODULE_2__/* .tagPropType */ .iC,
  className: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().string),
  cssModule: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().object)
};
var defaultProps = {
  tag: 'div'
};

var CardHeader = function CardHeader(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = (0,_babel_runtime_helpers_esm_objectWithoutPropertiesLoose__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(props, _excluded);

  var classes = (0,_utils__WEBPACK_IMPORTED_MODULE_2__/* .mapToCssModules */ .mx)(classnames__WEBPACK_IMPORTED_MODULE_1___default()(className, 'card-header'), cssModule);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(Tag, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, attributes, {
    className: classes
  }));
};

CardHeader.propTypes = propTypes;
CardHeader.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["Z"] = (CardHeader);

/***/ }),

/***/ 48312:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(93843);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 93843:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ MainPage; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(28354);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(60822);
// EXTERNAL MODULE: ./src/components/Layout/Layout.tsx + 23 modules
var Layout = __webpack_require__(62399);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(31382);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(61577);
// EXTERNAL MODULE: ./node_modules/reactstrap/es/Row.js
var Row = __webpack_require__(19343);
// EXTERNAL MODULE: ./node_modules/reactstrap/es/Col.js
var Col = __webpack_require__(70146);
// EXTERNAL MODULE: ./node_modules/recoil/es/index.js
var es = __webpack_require__(16130);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(37536);
// EXTERNAL MODULE: ./node_modules/reactstrap/es/Card.js
var Card = __webpack_require__(11215);
// EXTERNAL MODULE: ./node_modules/reactstrap/es/CardHeader.js
var CardHeader = __webpack_require__(65322);
// EXTERNAL MODULE: ./node_modules/reactstrap/es/CardBody.js
var CardBody = __webpack_require__(14191);
;// CONCATENATED MODULE: ./src/components/Common/Card.tsx
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  border: none;\n  border-image: none;\n  border-radius: 5px;\n  box-shadow: 1px 1px 10px 5px #5553;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  border: none;\n  border-image: none;\n  border-radius: 5px 5px 0 0 !important;\n  background-color: ",
        ";\n  color: ",
        ";\n  padding: 10px 10px;\n  display: flex;\n  height: 48px;\n  min-height: 48px;\n  max-height: 48px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  border: 0;\n  border-image: none;\n  margin: 3px 2px;\n  padding: 6px;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  margin: 5px;\n  box-shadow: none;\n  border-image: none;\n  border: #dfe2e6 1px solid;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  font-weight: bold;\n  font-size: 1.1rem;\n  padding: 7px 5px;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  margin: 3px 2px;\n  padding: 5px;\n  min-height: 180px;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}


/* Level 1 */ var CardL1 = (0,styled_components_browser_esm/* default */.ZP)(Card/* default */.Z).withConfig({
    componentId: "sc-9d32e4aa-0"
})(_templateObject());
var CardL1Header = (0,styled_components_browser_esm/* default */.ZP)(CardHeader/* default */.Z).withConfig({
    componentId: "sc-9d32e4aa-1"
})(_templateObject1(), function(props) {
    return props.theme.gray600;
}, function(props) {
    return props.theme.gray100;
});
var CardL1Body = (0,styled_components_browser_esm/* default */.ZP)(CardBody/* default */.Z).withConfig({
    componentId: "sc-9d32e4aa-2"
})(_templateObject2());
/* Level 2 */ var CardL2 = (0,styled_components_browser_esm/* default */.ZP)(Card/* default */.Z).withConfig({
    componentId: "sc-9d32e4aa-3"
})(_templateObject3());
var CardL2Header = (0,styled_components_browser_esm/* default */.ZP)(CardHeader/* default */.Z).withConfig({
    componentId: "sc-9d32e4aa-4"
})(_templateObject4());
var CardL2Body = (0,styled_components_browser_esm/* default */.ZP)(CardBody/* default */.Z).withConfig({
    componentId: "sc-9d32e4aa-5"
})(_templateObject5());

// EXTERNAL MODULE: ./node_modules/reactstrap/es/UncontrolledAlert.js
var UncontrolledAlert = __webpack_require__(86000);
// EXTERNAL MODULE: ./src/state/dataset.state.ts
var dataset_state = __webpack_require__(99902);
// EXTERNAL MODULE: ./src/helpers/useTranslationSafe.ts
var useTranslationSafe = __webpack_require__(87181);
// EXTERNAL MODULE: ./src/hooks/useRunSeqAutodetect.ts
var useRunSeqAutodetect = __webpack_require__(33035);
// EXTERNAL MODULE: ./src/state/autodetect.state.ts
var autodetect_state = __webpack_require__(26782);
;// CONCATENATED MODULE: ./src/components/Main/SuggestionAlertMainPage.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function SuggestionAlertMainPage_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function SuggestionAlertMainPage_templateObject() {
    var data = SuggestionAlertMainPage_taggedTemplateLiteral([
        "\n  display: flex;\n"
    ]);
    SuggestionAlertMainPage_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function SuggestionAlertMainPage_templateObject1() {
    var data = SuggestionAlertMainPage_taggedTemplateLiteral([
        "\n  margin: 0;\n  padding: 0.75rem 1rem;\n  width: 100%;\n\n  p {\n    margin: 0;\n  }\n"
    ]);
    SuggestionAlertMainPage_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}









function SuggestionAlertMainPage(_param) {
    var restProps = _extends({}, _param);
    var t = (0,useTranslationSafe/* useTranslationSafe */._)().t;
    var datasetCurrent = (0,es/* useRecoilValue */.sJ)(dataset_state/* datasetCurrentAtom */.W3);
    var ref = (0,useRunSeqAutodetect/* useDatasetSuggestionResults */.Ds)(), numSuggestions = ref.numSuggestions, datasetSuggestions = ref.datasetsActive;
    var autodetectRunState = (0,es/* useRecoilValue */.sJ)(autodetect_state/* autodetectRunStateAtom */.dZ);
    var alert = (0,react.useMemo)(function() {
        var hasMatch = datasetCurrent && datasetSuggestions.some(function(suggestion) {
            return suggestion.path === datasetCurrent.path;
        });
        if (autodetectRunState === autodetect_state/* AutodetectRunState.Failed */.vj.Failed) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Alert, {
                closeClassName: "d-none",
                fade: false,
                color: "danger",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                        className: "font-weight-bold",
                        children: t("Suggestion algorithm failed.")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "small",
                        children: t("Please report this to developers.")
                    })
                ]
            });
        }
        if (autodetectRunState === autodetect_state/* AutodetectRunState.Done */.vj.Done) {
            if (datasetCurrent) {
                // There is more than one suggestion and selected dataset is NOT among them
                if (!hasMatch && numSuggestions > 0) {
                    var text = t("Currently selected dataset does not seem to match your sequences, " + 'but there are {{ n }} other datasets which might. Click "Change reference dataset" to see the list.', {
                        n: numSuggestions
                    });
                    if (numSuggestions === 1) {
                        text = t("Currently selected dataset does not seem to match your sequences, " + 'but there is 1 dataset which might. Click "Change reference dataset" to see the list.');
                    }
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Alert, {
                        closeClassName: "d-none",
                        fade: false,
                        color: "warning",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                className: "font-weight-bold",
                                children: t("Possible dataset mismatch detected.")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "small",
                                children: text
                            })
                        ]
                    });
                }
                // There is more than one suggestion and selected dataset is among them
                if (numSuggestions > 1) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Alert, {
                        closeClassName: "d-none",
                        fade: false,
                        color: "primary",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                className: "font-weight-bold",
                                children: t("Multiple matching datasets.")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "small",
                                children: t('{{ n }} datasets appear to match your sequences. Click "Change reference dataset" to see the list.', {
                                    n: numSuggestions
                                })
                            })
                        ]
                    });
                }
            }
            // There is no suggestions
            if (numSuggestions === 0) {
                if (datasetCurrent) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Alert, {
                        closeClassName: "d-none",
                        fade: false,
                        color: "danger",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                className: "font-weight-bold",
                                children: t("Possible dataset mismatch detected.")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "small",
                                children: t("Currently selected dataset does not seem to match your sequences and suggestion algorithm was unable to find any alternatives. Select a dataset manually. If there is no suitable dataset, consider creating and contributing one to Nextclade community dataset collection.")
                            })
                        ]
                    });
                }
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Alert, {
                    closeClassName: "d-none",
                    fade: false,
                    color: "danger",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                            className: "font-weight-bold",
                            children: t("No matching datasets.")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "small",
                            children: t("Suggestion algorithm was unable to find a dataset suitable for your sequences. Select a dataset manually. If there is no suitable dataset, consider creating and contributing one to Nextclade community dataset collection.")
                        })
                    ]
                });
            }
        }
        return null;
    }, [
        autodetectRunState,
        datasetCurrent,
        datasetSuggestions,
        numSuggestions,
        t
    ]);
    if (!alert) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
        noGutters: true,
        className: "my-1",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AlertWrapper, _objectSpread({}, restProps, {
                children: alert
            }))
        })
    });
}
var AlertWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-feda267c-0"
})(SuggestionAlertMainPage_templateObject());
var Alert = (0,styled_components_browser_esm/* default */.ZP)(UncontrolledAlert/* default */.Z).withConfig({
    componentId: "sc-feda267c-1"
})(SuggestionAlertMainPage_templateObject1());

// EXTERNAL MODULE: ./src/state/inputs.state.ts
var inputs_state = __webpack_require__(67821);
// EXTERNAL MODULE: ./src/io/fetchDatasets.ts + 1 modules
var fetchDatasets = __webpack_require__(97668);
// EXTERNAL MODULE: ./node_modules/reactstrap/es/Button.js
var Button = __webpack_require__(21602);
;// CONCATENATED MODULE: ./src/components/Main/ButtonChangeDataset.tsx
function ButtonChangeDataset_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function ButtonChangeDataset_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            ButtonChangeDataset_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function ButtonChangeDataset_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function ButtonChangeDataset_templateObject() {
    var data = ButtonChangeDataset_taggedTemplateLiteral([
        "\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  overflow: hidden;\n\n  padding: 12px;\n  border: 1px #ccc9 solid;\n  border-radius: 5px;\n\n  min-height: 200px;\n"
    ]);
    ButtonChangeDataset_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ButtonChangeDataset_templateObject1() {
    var data = ButtonChangeDataset_taggedTemplateLiteral([
        "\n  min-height: 50px;\n"
    ]);
    ButtonChangeDataset_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}








function DatasetNoneSection(param) {
    var toDatasetSelection = param.toDatasetSelection;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonChangeDataset, {
            onClick: toDatasetSelection
        })
    });
}
var Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-d351807b-0"
})(ButtonChangeDataset_templateObject());
function ButtonChangeDataset(_param) {
    var onClick = _param.onClick, restProps = _objectWithoutProperties(_param, [
        "onClick"
    ]);
    var t = (0,useTranslationSafe/* useTranslationSafe */._)().t;
    var dataset = (0,es/* useRecoilValue */.sJ)(dataset_state/* datasetCurrentAtom */.W3);
    var ref = (0,react.useMemo)(function() {
        var hasDataset = !(0,lodash.isNil)(dataset);
        var text = hasDataset ? t("Change reference dataset") : t("Select reference dataset");
        return {
            color: hasDataset ? "secondary" : "primary",
            text: text,
            tooltip: text
        };
    }, [
        dataset,
        t
    ]), color = ref.color, text1 = ref.text, tooltip = ref.tooltip;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonChangeDatasetStyled, ButtonChangeDataset_objectSpread({
        className: "m-auto",
        color: color,
        title: tooltip,
        onClick: onClick
    }, restProps, {
        children: text1
    }));
}
var ButtonChangeDatasetStyled = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z).withConfig({
    componentId: "sc-d351807b-1"
})(ButtonChangeDataset_templateObject1());

// EXTERNAL MODULE: ./src/components/Main/ButtonRun.tsx
var ButtonRun = __webpack_require__(16968);
// EXTERNAL MODULE: ./node_modules/react-icons/md/index.esm.js
var index_esm = __webpack_require__(10872);
// EXTERNAL MODULE: ./src/components/Common/ButtonTransparent.tsx
var ButtonTransparent = __webpack_require__(13707);
// EXTERNAL MODULE: ./src/components/Main/ButtonLoadExample.tsx
var ButtonLoadExample = __webpack_require__(54049);
// EXTERNAL MODULE: ./src/components/Main/DatasetCustomizationIndicator.tsx
var DatasetCustomizationIndicator = __webpack_require__(51787);
// EXTERNAL MODULE: ./src/components/Main/LinkOpenTree.tsx
var LinkOpenTree = __webpack_require__(98409);
// EXTERNAL MODULE: ./src/components/Main/DatasetCurrentUpdateNotification.tsx
var DatasetCurrentUpdateNotification = __webpack_require__(90485);
// EXTERNAL MODULE: ./src/components/Main/DatasetInfo.tsx + 2 modules
var DatasetInfo = __webpack_require__(37952);
;// CONCATENATED MODULE: ./src/components/Main/DatasetCurrentSummary.tsx
function DatasetCurrentSummary_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function DatasetCurrentSummary_templateObject() {
    var data = DatasetCurrentSummary_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  padding: 12px;\n  border: 1px #ccc9 solid;\n  border-radius: 5px;\n  min-height: 200px;\n"
    ]);
    DatasetCurrentSummary_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function DatasetCurrentSummary_templateObject1() {
    var data = DatasetCurrentSummary_taggedTemplateLiteral([
        "\n  display: inline;\n  margin-left: auto;\n  height: 20px;\n  width: 20px;\n"
    ]);
    DatasetCurrentSummary_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function DatasetCurrentSummary_templateObject2() {
    var data = DatasetCurrentSummary_taggedTemplateLiteral([
        "\n  * {\n    color: ",
        ";\n  }\n"
    ]);
    DatasetCurrentSummary_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function DatasetCurrentSummary_templateObject3() {
    var data = DatasetCurrentSummary_taggedTemplateLiteral([
        "\n  margin-left: 90px;\n"
    ]);
    DatasetCurrentSummary_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}















function DatasetCurrentSummary() {
    // Periodically checks if there's local update for the current dataset
    (0,fetchDatasets/* useUpdatedDataset */.EI)();
    var t = (0,useTranslationSafe/* useTranslationSafe */._)().t;
    var dataset = (0,es/* useRecoilValue */.sJ)(dataset_state/* datasetCurrentAtom */.W3);
    var resetDataset = (0,es/* useResetRecoilState */.rb)(dataset_state/* datasetCurrentAtom */.W3);
    if (!dataset) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(DatasetCurrentSummary_Container, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DatasetCurrentUpdateNotification/* DatasetCurrentUpdateNotification */.G, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                noGutters: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Col/* default */.Z, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                            noGutters: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                className: "d-flex",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonClear, {
                                    onClick: resetDataset,
                                    title: t("Reset dataset"),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconClear, {
                                        size: 20
                                    })
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                            noGutters: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DatasetInfo/* DatasetInfo */.Bu, {
                                    dataset: dataset,
                                    showSuggestions: true
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                            noGutters: true,
                            className: "d-flex",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                className: "d-flex mr-auto mt-2",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DatasetCustomizationWrapper, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DatasetCustomizationIndicator/* DatasetCustomizationsIndicatorLink */.GT, {})
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                            noGutters: true,
                            className: "d-flex w-100",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                className: "d-flex",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "d-flex ml-auto",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkOpenTree/* LinkOpenTree */.$, {
                                            className: "my-auto",
                                            dataset: dataset
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonLoadExample/* ButtonLoadExample */.P, {})
                                    ]
                                })
                            })
                        })
                    ]
                })
            })
        ]
    });
}
var DatasetCurrentSummary_Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-bc14333d-0"
})(DatasetCurrentSummary_templateObject());
var ButtonClear = (0,styled_components_browser_esm/* default */.ZP)(ButtonTransparent/* ButtonTransparent */.h).withConfig({
    componentId: "sc-bc14333d-1"
})(DatasetCurrentSummary_templateObject1());
var IconClear = (0,styled_components_browser_esm/* default */.ZP)(index_esm/* MdClear */.lUB).withConfig({
    componentId: "sc-bc14333d-2"
})(DatasetCurrentSummary_templateObject2(), function(props) {
    return props.theme.gray500;
});
var DatasetCustomizationWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-bc14333d-3"
})(DatasetCurrentSummary_templateObject3());

// EXTERNAL MODULE: ./src/components/Main/MainSectionTitle.tsx + 2 modules
var MainSectionTitle = __webpack_require__(87319);
// EXTERNAL MODULE: ./src/hooks/useRunAnalysis.ts + 2 modules
var useRunAnalysis = __webpack_require__(87443);
// EXTERNAL MODULE: ./src/hooks/useToggle.ts
var useToggle = __webpack_require__(83144);
// EXTERNAL MODULE: ./src/state/error.state.ts
var error_state = __webpack_require__(57635);
// EXTERNAL MODULE: ./src/state/settings.state.ts
var settings_state = __webpack_require__(99664);
// EXTERNAL MODULE: ./src/components/FilePicker/FilePicker.tsx + 13 modules
var FilePicker = __webpack_require__(4905);
// EXTERNAL MODULE: ./src/components/Common/FileIcons.tsx
var FileIcons = __webpack_require__(4052);
;// CONCATENATED MODULE: ./src/components/Main/QuerySequenceFilePicker.tsx
function QuerySequenceFilePicker_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function QuerySequenceFilePicker_templateObject() {
    var data = QuerySequenceFilePicker_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n"
    ]);
    QuerySequenceFilePicker_templateObject = function _templateObject() {
        return data;
    };
    return data;
}













function QuerySequenceFilePicker() {
    var t = (0,useTranslationSafe/* useTranslationSafe */._)().t;
    var addQryInputs = (0,inputs_state/* useQuerySeqInputs */.HT)().addQryInputs;
    var qrySeqError = (0,es/* useRecoilValue */.sJ)(error_state/* qrySeqErrorAtom */.vm);
    var ref = (0,useToggle/* useRecoilToggle */.T)(settings_state/* shouldRunAutomaticallyAtom */.B6), shouldRunAutomatically = ref.state;
    var shouldSuggestDatasetsOnDatasetPage = (0,es/* useRecoilValue */.sJ)(settings_state/* shouldSuggestDatasetsOnDatasetPageAtom */.Ji);
    var icon = (0,react.useMemo)(function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(FileIcons/* FileIconFasta */.Dt, {});
    }, []);
    var runAnalysis = (0,useRunAnalysis/* useRunAnalysis */.B)();
    var runAutodetect = (0,useRunSeqAutodetect/* useRunSeqAutodetect */.oh)();
    var setSequences = (0,react.useCallback)(function(inputs) {
        addQryInputs(inputs);
        if (shouldSuggestDatasetsOnDatasetPage) {
            runAutodetect();
        }
        if (shouldRunAutomatically) {
            runAnalysis();
        }
    }, [
        addQryInputs,
        runAnalysis,
        runAutodetect,
        shouldRunAutomatically,
        shouldSuggestDatasetsOnDatasetPage
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(QuerySequenceFilePicker_Container, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FilePicker/* FilePicker */.GB, {
            icon: icon,
            exampleUrl: "https://example.com/sequences.fasta",
            pasteInstructions: t("Enter sequence data in FASTA format"),
            input: undefined,
            error: qrySeqError,
            isInProgress: false,
            onInputs: setSequences,
            multiple: true
        })
    });
}
var QuerySequenceFilePicker_Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1f7b4663-0"
})(QuerySequenceFilePicker_templateObject());

// EXTERNAL MODULE: ./src/components/Main/QuerySequenceList.tsx
var QuerySequenceList = __webpack_require__(55375);
// EXTERNAL MODULE: ./src/components/Help/SelectDatasetHelp.tsx
var SelectDatasetHelp = __webpack_require__(85800);
// EXTERNAL MODULE: ./src/components/Main/SuggestionPanel.tsx + 1 modules
var SuggestionPanel = __webpack_require__(3428);
;// CONCATENATED MODULE: ./src/components/Main/MainInputForm.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function MainInputForm_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function MainInputForm_templateObject() {
    var data = MainInputForm_taggedTemplateLiteral([
        "\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  width: 100%;\n  margin: 0 auto;\n  max-width: 1200px;\n"
    ]);
    MainInputForm_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function MainInputForm_templateObject1() {
    var data = MainInputForm_taggedTemplateLiteral([
        "\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n"
    ]);
    MainInputForm_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function MainInputForm_templateObject2() {
    var data = MainInputForm_taggedTemplateLiteral([
        "\n  display: flex;\n  flex: 0;\n  padding-left: 10px;\n  margin-top: 10px;\n  margin-bottom: 3px;\n"
    ]);
    MainInputForm_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function MainInputForm_templateObject3() {
    var data = MainInputForm_taggedTemplateLiteral([
        "\n  flex: 1;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  margin: -12px;\n  padding: 12px;\n  overflow: hidden;\n"
    ]);
    MainInputForm_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function MainInputForm_templateObject4() {
    var data = MainInputForm_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: row;\n  width: 100%;\n  margin: -12px;\n  padding: 12px;\n  margin-left: auto;\n  margin-right: auto;\n  overflow: hidden;\n"
    ]);
    MainInputForm_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function MainInputForm_templateObject5() {
    var data = MainInputForm_taggedTemplateLiteral([
        ""
    ]);
    MainInputForm_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = MainInputForm_taggedTemplateLiteral([
        "\n  //min-height: 386px;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = MainInputForm_taggedTemplateLiteral([
        "\n  display: inline-flex;\n  flex: 1 0;\n  padding-left: 0.75rem;\n  margin: auto 0;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
























var ContainerFixed = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-412457be-0"
})(MainInputForm_templateObject());
var MainInputForm_Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-412457be-1"
})(MainInputForm_templateObject1());
var Header = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-412457be-2"
})(MainInputForm_templateObject2());
var Main = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-412457be-3"
})(MainInputForm_templateObject3());
var RowCustom = (0,styled_components_browser_esm/* default */.ZP)(Row/* default */.Z).withConfig({
    componentId: "sc-412457be-4"
})(MainInputForm_templateObject4());
function Landing() {
    // This periodically fetches dataset index and updates the list of datasets.
    (0,fetchDatasets/* useUpdatedDatasetIndex */.Uq)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContainerFixed, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Header, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MainSectionTitle/* MainSectionTitle */.p, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Main, {
                className: "mt-4 mb-2",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(RowCustom, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                            md: 6,
                            className: "d-flex flex-column h-100",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LandingCardQuerySeqPicker, {})
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                            md: 6,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LandingCardDataset, {})
                        })
                    ]
                })
            })
        ]
    });
}
function LandingCardQuerySeqPicker() {
    var t = (0,useTranslationSafe/* useTranslationSafe */._)().t;
    var qryInputs = (0,inputs_state/* useQuerySeqInputs */.HT)().qryInputs;
    var title = (0,react.useMemo)(function() {
        if (qryInputs.length > 0) {
            return t("Add more sequence data");
        }
        return t("Provide sequence data");
    }, [
        qryInputs.length,
        t
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(MainInputForm_CardL1, {
        className: "d-flex flex-column h-100",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CardL1Header, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardTitle, {
                    title: title,
                    children: title
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(MainInputForm_CardL1Body, {
                className: "d-flex flex-column h-100",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(QuerySequenceFilePicker, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(QuerySequenceList/* QuerySequenceList */.g2, {})
                ]
            })
        ]
    });
}
function LandingCardDataset() {
    var t = (0,useTranslationSafe/* useTranslationSafe */._)().t;
    var dataset = (0,es/* useRecoilValue */.sJ)(dataset_state/* datasetCurrentAtom */.W3);
    var text = (0,react.useMemo)(function() {
        if ((0,lodash.isNil)(dataset)) {
            return t("Select reference dataset");
        }
        return t("Selected reference dataset");
    }, [
        dataset,
        t
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(MainInputForm_CardL1, {
        className: "d-flex flex-column h-100",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CardL1Header, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardTitle, {
                    children: [
                        text,
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectDatasetHelp/* SelectDatasetHelp */.W, {})
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MainInputForm_CardL1Body, {
                className: "d-flex flex-column h-100",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DatasetCurrentOrSelectButton, {})
            })
        ]
    });
}
var MainInputForm_CardL1 = (0,styled_components_browser_esm/* default */.ZP)(CardL1).withConfig({
    componentId: "sc-412457be-5"
})(MainInputForm_templateObject5());
var MainInputForm_CardL1Body = (0,styled_components_browser_esm/* default */.ZP)(CardL1Body).withConfig({
    componentId: "sc-412457be-6"
})(_templateObject6());
var CardTitle = styled_components_browser_esm/* default.h4.withConfig */.ZP.h4.withConfig({
    componentId: "sc-412457be-7"
})(_templateObject7());
function DatasetCurrentOrSelectButton() {
    var run = (0,useRunAnalysis/* useRunAnalysis */.B)();
    var ref = _slicedToArray((0,es/* useRecoilState */.FV)(dataset_state/* datasetCurrentAtom */.W3), 2), dataset = ref[0], setDataset = ref[1];
    var topSuggestion = (0,useRunSeqAutodetect/* useDatasetSuggestionResults */.Ds)().topSuggestion;
    var autodetectShouldSetCurrentDataset = (0,es/* useRecoilValue */.sJ)(autodetect_state/* autodetectShouldSetCurrentDatasetAtom */.l8);
    (0,react.useEffect)(function() {
        if (!dataset || autodetectShouldSetCurrentDataset) {
            setDataset(topSuggestion);
        }
    }, [
        autodetectShouldSetCurrentDataset,
        dataset,
        setDataset,
        topSuggestion
    ]);
    var push = (0,router.useRouter)().push;
    var toDatasetSelection = (0,react.useCallback)(function() {
        // eslint-disable-next-line no-void
        void push("/dataset");
    }, [
        push
    ]);
    if (!dataset) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(MainInputForm_Container, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                    noGutters: true,
                    className: "mb-1",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SuggestionPanel/* SuggestionPanel */.wP, {})
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                    noGutters: true,
                    className: "my-1",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DatasetNoneSection, {
                            toDatasetSelection: toDatasetSelection
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(SuggestionAlertMainPage, {
                    className: "mt-1 w-100"
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(MainInputForm_Container, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                noGutters: true,
                className: "mb-1",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SuggestionPanel/* SuggestionPanel */.wP, {})
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                noGutters: true,
                className: "my-1",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DatasetCurrentSummary, {})
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                noGutters: true,
                className: "my-1",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Col/* default */.Z, {
                    className: "d-flex w-100",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonChangeDataset, {
                            className: "mr-auto",
                            onClick: toDatasetSelection
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonRun/* ButtonRun */.H, {
                            className: "ml-auto",
                            onClick: run
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SuggestionAlertMainPage, {
                className: "mt-1 w-100"
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/components/Main/MainPage.tsx
function MainPage_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function MainPage_templateObject() {
    var data = MainPage_taggedTemplateLiteral([
        "\n  display: flex;\n  flex: 1 1 100%;\n  overflow: hidden;\n  padding: 0;\n  margin: 0 auto;\n\n  width: 100%;\n  max-width: 1400px;\n"
    ]);
    MainPage_templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var MainPage_Main = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-17bf850c-0"
})(MainPage_templateObject());
function MainPage() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Layout/* Layout */.A, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MainPage_Main, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Landing, {})
        })
    });
}

;// CONCATENATED MODULE: ./src/pages/index.tsx



/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [361,445,189,603,810,774,888,179], function() { return __webpack_exec__(48312); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);